<template>
  <article class="article-card" :id="headerId">
    <!-- This is a single card. Multiple Cards of a similar product might be needed.  Loop outside this component and pass in-->
    <header v-if="slug !== 'recent-announcements'" class="article-card__header">
      <div v-if="isNew === 'true'" class="article-card__new" />
      <a
        v-if="!purchased && purchased != null"
        v-on:click="goToUnlockPage(buttonUrl)"
      >
        <div
          v-if="!purchased && purchased != null"
          class="article-card__locked"
        />
      </a>
      <a
        v-if="playBtn && (purchased || purchased == null)"
        v-on:click="goToPage(slug)"
      >
        <div v-if="playBtn" class="article-card__play" />
      </a>
      <a
        v-if="popOut && (purchased || purchased == null)"
        v-on:click="goToPage(slug)"
      >
        <div v-if="popOut" class="article-card__popout" />
      </a>
      <div class="embed-header-container">
        <iframe
          v-if="vimeoId"
          :src="getVideo()"
          frameborder="0"
          webkitAllowFullScreen
          mozallowfullscreen
          allowFullScreen
        />
        <iframe
          v-if="youtubeCode"
          :src="getYTVideo()"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
        <!-- <div class="article-card--image image-zoom"> -->
        <img
          v-if="hasImage"
          :src="'/app/public/' + imagePath"
          alt="Image"
          id="article-img"
        />
      </div>
      <!-- </div> -->
      <!-- <img v-if="hasImage" :src="'/app/public/' + imagePath" alt="Image" id="article-img"> -->
      <!-- <img v-if="hasImage" src="/images/itr_academy_test.png" alt="Image"> -->
    </header>
    <section v-if="slug === 'itr-academy'" class="article-card__body academy">
      <p class="product-display-title" v-if="title">
        <a :href="'/app/public/' + buttonUrl">{{ title }}</a>
      </p>
      <p class="product-display-subtitle" v-else="subTitle">
        <a :href="'/app/public/' + buttonUrl">{{ subTitle }}</a>
      </p>
      <p v-if="date" class="product-display-date">{{ date }}</p>
      <p v-if="!date && otherDate" class="product-display-date">
        {{ otherDate }}
      </p>
      <div
        v-if="description"
        v-html="description"
        class="product-display-description"
      ></div>
      <p v-if="readMore" class="product-display-read-more">
        <a :href="buttonUrl">Read Article</a>
      </p>
      <p v-if="hasButton" class="button-green product-display-read-more-button">
        <a :href="buttonUrl">{{ buttonName }}</a>
      </p>
    </section>
    <section v-else class="article-card__body">
      <p class="product-display-title" v-if="title" v-on:click="goToPage(slug)">
        {{ title }}
      </p>
      <p
        class="product-display-subtitle"
        v-else="subTitle"
        v-on:click="goToPage(slug)"
      >
        {{ subTitle }}
      </p>
      <p v-if="date" class="product-display-date">{{ date }}</p>
      <p v-if="!date && otherDate" class="product-display-date">
        {{ otherDate }}
      </p>
      <div
        v-if="description && slug === 'recent-announcements'"
        class="product-display-description"
      >
        <p>{{ trimString(description) }}</p>
      </div>
      <div
        v-if="description && slug !== 'recent-announcements'"
        v-html="description"
        class="product-display-description"
      ></div>
      <p v-if="readMore" class="product-display-read-more">
        <a :href="buttonUrl">Read Article</a>
      </p>
      <p v-if="hasButton" class="button-green product-display-read-more-button">
        <a :href="buttonUrl">{{ buttonName }}</a>
        <!-- <a :href="'/storage/' + feed[0].webinars[0].pptAttachment"></a> -->
      </p>
    </section>
  </article>
</template>

<script>
  export default {
    name: 'ProductDisplayComponent',
    props: {
      productId: {
        type: Number,
        // required: true,
      },
      headerId: {
        type: String,
        // required: true,
      },
      title: {
        type: String,
        // required: true,
      },
      date: {
        type: String,
        // required: true,
      },
      otherDate: {
        type: String,
        // required: true,
      },
      description: {
        type: String,
        // required: true,
      },
      vimeoId: {
        type: String,
        // required: true,
      },
      buttonUrl: {
        type: String,
        // required: true,
      },
      buttonName: {
        type: String,
        // required: true,
      },
      readMore: {
        value: [String, Boolean],
        // required: true,
      },
      hasButton: {
        type: Boolean,
        // required: true,
      },
      purchased: {
        value: [String, Boolean],
        // required: true,
      },
      isNew: {
        type: String,
      },
      popOut: {
        value: [String, Boolean],
        // type: String,
      },
      playBtn: {
        value: [String, Boolean],
      },
      hasImage: {
        type: Boolean,
      },
      imagePath: {
        type: String,
      },
      youtubeCode: {
        type: String,
      },
      subTitle: {
        type: String,
      },
      slug: {
        type: String,
      },
      productTitle: {
        type: String,
      },
      pptAttachment: {
        type: String,
      },
      pptSize: {
        type: String,
      },
      pptName: {
        type: String,
      },
      // testRead:
    },
    data: () => ({
      scrollPosition: 0,
      ismobiledevice: false,
      jsonReady: true,
      hasVideo: true,
    }),
    mounted() {},
    methods: {
      trimString(html) {
        let trim = html.replace(/<(?:.|\n)*?>/gm, '');
        let resultString = trim.split(' ').slice(0, 15).join(' ') + '...';

        return resultString;
      },
      getVideo() {
        return 'https://player.vimeo.com/video/' + this.vimeoId;
      },
      getYTVideo() {
        return 'https://www.youtube.com/embed/' + this.youtubeCode;
      },
      goToPage: function (slug) {
        let url = window.location.origin;
        url = url + '/insider/' + slug + '/' + this.productId;
        window.location.href = url;
      },
      goToUnlockPage: function (redirect) {
        let url = window.location.origin;
        url = url + '/store/product/' + redirect;
        window.location.href = url;

        // window.location.href = 'http://local.itrondemand.com/store/product/2023-in-our-sights-manufacturing';
        // window.location.href = 'http://local.itrondemand.com/store/product/2023-in-our-sights-manufacturing';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .article-card {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    width: 400px;
    border: none;

    &__header {
      position: relative;
      border: none;

      .embed-header-container {
        background: none;
        bottom: 0%;
        width: 100%;
        position: relative;
        overflow: hidden;
        height: calc(28vh);

        iframe,
        object,
        embed {
          // position: absolute;
          // top: 0;
          // left: 0;
          width: 100%;
          height: 100%;
        }
      }

      #article-img {
        transition: all $default-transition-time;
      }

      #article-img {
        min-height: 250px;
        min-width: 400px;
        background: lightgrey;
        border-radius: 5px;
      }

      &:hover {
        #article-img {
          @include screen-xl {
            transform: scale(1.1);
          }

          @include screen-xxl {
            transform: scale(1.05);
          }
        }
      }
    }

    &__locked {
      position: absolute;
      background: rgba(0, 0, 0, 0.5);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99999;
      width: 100%;
      padding-bottom: 57%;
      overflow: hidden;
      max-width: 100%;
      margin-bottom: 20px;
      height: 0;

      cursor: pointer;

      &::before {
        content: url('/images/closed-lock.svg');
        transform: scale(0.6);
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }

      &:hover {
        &::before {
          content: url('/images/open-lock.svg');
        }
      }
    }

    &__play {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99999;
      width: 100%;
      padding-bottom: 57%;
      overflow: hidden;
      max-width: 100%;
      margin-bottom: 20px;
      height: 0;

      cursor: pointer;

      // &::before {
      //     content: url('/images/play icon.png');
      //     transform: scale(0.6);
      //     position: absolute;
      //     display: flex;
      //     justify-content: center;
      //     align-items: center;
      //     width: 100%;
      //     height: 100%;
      //     top: 0;
      //     bottom: 0;
      //     left: 0;
      //     right: 0;
      // }

      &:hover {
        &::before {
          content: url('/images/play-icon.png');
          background: rgba(0, 0, 0, 0.5);
          // transform: scale(0.6);
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99999;
          height: 100%;
          width: 100%;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
    }

    &__popout {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99999;
      width: 100%;
      padding-bottom: 57%;
      overflow: hidden;
      max-width: 100%;
      margin-bottom: 20px;
      height: 0;

      cursor: pointer;

      &:hover {
        &::before {
          content: url('/images/pop-out.png');
          background: rgba(0, 0, 0, 0.5);
          // transform: scale(0.6);
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
        }
      }
    }

    &__new {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 99999;
      height: 100%;
      width: 100%;
      // background: rgba(0, 0, 0, 0.5);

      // cursor: pointer;

      &::before {
        content: url('/images/new-banner.png');
        transform: scale(0.9);
        position: absolute;
        display: flex;
        /* justify-content: center; */
        /* align-items: center; */
        /* width: 100%; */
        /* height: 100%; */
        top: -11px;
        /* bottom: 0; */
        /* left: 0; */
        right: -10px;
      }
    }

    &__body {
      display: flex;
      flex-direction: column;

      .product-display-title {
        font-size: 25px;
        color: #183961;
        font-weight: 900;

        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .product-display-subtitle {
        font-size: 18px;
        color: #3075a4;
        font-weight: 900;

        &:hover {
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .product-display-date {
        color: #a7a9ab;
        font-size: 15px;
      }

      .button-green.product-display-read-more-button {
        a {
          color: #fff;
        }
      }
    }

    &__body.academy {
      display: flex;
      flex-direction: row;
      align-items: center;
      // justify-content: center;
      gap: 5px;
      margin-top: 1em;

      .product-display-title {
        font-size: 25px;
        color: #183961;
        font-weight: 900;
      }

      .product-display-subtitle {
        font-size: 18px;
        color: #3075a4;
        font-weight: 900;
        width: 80%;
      }
      .product-display-date {
        color: #a7a9ab;
        font-size: 15px;
      }

      .button-green.product-display-read-more-button {
        width: 50%;
        text-align: center;
        margin-top: 0px;
        a {
          color: #fff;
        }
      }
    }
  }
</style>
